import { render } from "./JustRelease.vue?vue&type=template&id=27050e1b"
import script from "./JustRelease.vue?vue&type=script&lang=js"
export * from "./JustRelease.vue?vue&type=script&lang=js"

import "./JustRelease.vue?vue&type=style&index=0&id=27050e1b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__